module.exports = __webpack_public_path__ + "static/media/description-pic.cb3a1c3e.png";